/**
 * 章节测验的API
 */

import request from '@/utils/request'

const apis = {
  GET_QUESTION_LIST: '/lesson/getquestionlist',
  START_EXAM: '/lesson/startexamination',
  GO_NEXT_LESSON:'/lesson/goNextLesson',
  FINISH_EXAM: '/lesson/finishexamination',
  FINISH_EXAM2: '/lesson/finishexamination2',
  SENDLOGGER : '/user/jslog/send'

}

export default {
  // 信息列表
  getQuestionList (data) {
    let dt = data || {}
    return request.post(apis.GET_QUESTION_LIST, dt.params, {
      headers: dt.headers || {}
    })
  },
    goNextLesson (data) {
        let dt = data || {}
        return request.post(apis.GO_NEXT_LESSON, dt.params, {
            headers: dt.headers || {}
        })
    },
  startExam (data) {
    let dt = data || {}
    return request.post(apis.START_EXAM, dt.params, {
      headers: dt.headers || {}
    })
  },
  finishExam (data) {
    let dt = data || {}
    return request.post(apis.FINISH_EXAM, dt.params, {
      headers: dt.headers || {}
    })
  },
    finishExam2 (data) {
    let dt = data || {}
    return request.post(apis.FINISH_EXAM2, dt.params, {
      headers: dt.headers || {}
    })
  },
    sendJSLogger(data){
        let dt = data || {}
        return request.post(apis.SENDLOGGER, dt.params, {
            headers: dt.headers || {}
        })
    }
}



// WEBPACK FOOTER //
// ./src/api/test.js



// WEBPACK FOOTER //
// ./src/api/test.js